import * as React from 'react';

import { compose } from '../../../../../utils/component-helpers';

import { withModalActions, ModalActionProps } from '../../Modals/modalActions';
import { ModalReceiverProps } from '../../Modals/ModalManager';

import { DetailViewFeed } from '../../ContentPane/DetailView/MainTabs/DetailViewFeed';
import { MobileSubmenuSlider } from '@cube3/cubicle/src/components/Surface/MobileSubmenuSlider';

/**Display the activity view in a modal when isMobile */

type Properties = ModalActionProps & ModalReceiverProps & MobileAssetActivity;

interface MobileAssetActivity {}

function MobileAssetActivity(props: Properties) {
  const { modalContext, previousModal } = props;
  const { asset } = modalContext;

  return (
    <MobileSubmenuSlider onClose={previousModal}>
      <DetailViewFeed asset={asset} />
    </MobileSubmenuSlider>
  );
}

export default compose(MobileAssetActivity)(withModalActions);
